import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  'data-color-scheme-picker'?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, className = '', 'data-color-scheme-picker': isColorSchemePicker, ...props }) => {
  return (
    <div 
      className={`bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden ${className} ${isColorSchemePicker ? 'preserve-original-colors' : ''}`}
      {...(isColorSchemePicker && { 'data-color-scheme-picker': true })}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardHeader: React.FC<CardProps> = ({ children, className = '' }) => {
  return (
    <div className={`px-6 py-4 border-b border-gray-100 dark:border-gray-700 ${className}`}>
      {children}
    </div>
  );
};

export const CardTitle: React.FC<CardProps> = ({ children, className = '' }) => {
  return (
    <h3 className={`text-lg font-semibold text-gray-900 dark:text-white ${className}`}>
      {children}
    </h3>
  );
};

export const CardDescription: React.FC<CardProps> = ({ children, className = '' }) => {
  return (
    <p className={`mt-1 text-sm text-gray-600 dark:text-gray-200 ${className}`}>
      {children}
    </p>
  );
};

export const CardContent: React.FC<CardProps> = ({ children, className = '' }) => {
  return (
    <div className={`px-6 py-4 text-gray-900 dark:text-white ${className}`}>
      {children}
    </div>
  );
};

export const CardFooter: React.FC<CardProps> = ({ children, className = '' }) => {
  return (
    <div className={`px-6 py-4 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white ${className}`}>
      {children}
    </div>
  );
};